import { useState } from "react";
import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { DataUtils } from "../../common/views/DataUtils";
import { PictureModel } from "../../pictures/models/PictureModel";
import { PaymentModel } from "../models/PaymentModels";
import { PaymentService } from "../services/PaymentService";

export function usePaymentDetailVM() {
    const paymentService = new PaymentService();

    const [payment, setPayment] = useState<PaymentModel | null>(null);
    const [pictures, setPictures] = useState<PictureModel[]>([]);
    const [loading, setLoading] = useState(false);

    const [selectedInvoice, setSelectedInvoice] = useState<string>("");
    const [showInvoice, setShowInvoice] = useState<boolean>(false);

    const get = (id: string) => {
        setLoading(true);
        setPayment(null);
        const request = paymentService.get(id);
        DataUtils.onRequest(request, onGetResult);
    }

    const onGetResult = (result: IDataResult) => {
        const payment = result.data as PaymentModel | null | undefined;

        if (payment != null) {
            setPayment(payment);
        }

        setLoading(false);
    }

    const getPictures = (id: string) => {
        const onResult = (result: IDataResult) => {
            if (result.status === ResponseStatus.success) {
                setPictures(result.data);
            }
        }

        const request = paymentService.getPictures(id);
        DataUtils.onRequest(request, onResult);
    }

    return {
        payment, setPayment,
        pictures, setPictures,

        loading, setLoading,
        selectedInvoice, setSelectedInvoice,
        showInvoice, setShowInvoice,

        get,
        getPictures
    }
}